<template>
    <div class="Bot">
        <v-container grid-list-md grid-list-xs text-xs-center>
            <v-layout row wrap>
                <v-flex v-bind:class="{ xs6: !mobile, xs12: mobile }" class="sm6, md3">
                    <v-card
                        hover
                        color="primary"
                        dark
                        height="100%"
                        @click="createBot"
                    >
                        <v-card-title>
                            <v-row justify="center">
                                <v-icon>add</v-icon>
                            </v-row>
                        </v-card-title>
                        <v-card-text>
                            <v-row justify="center">
                                <span class="body-1 font-weight-light text-center"
                                      @click.self="showCreateForm=true"
                                >Создать</span>
                            </v-row>
                            <!--Старый тип создания бота-->
                            <!--                            <v-row justify="center">
                                                            <span class="body-1 font-weight-light text-center"
                                                                  @click.self="showScheduleForm=true"
                                                            >Создать</span>
                                                        </v-row>-->
                        </v-card-text>
                    </v-card>
                </v-flex>
                <bot-card v-for="(bot, parentIndex) in bots"
                          :key="bot.id"
                          :parent-index="parentIndex"
                          :bot="bot"
                          :mobile="mobile"
                          @removeBot="removeBot"
                          @editBot="editBot"
                ></bot-card>
            </v-layout>
        </v-container>
        <dialog-confirmation ref="confirm"></dialog-confirmation>
        <BotForm :visible="showScheduleForm" :botIndex="botIndex"
                 @close="showScheduleForm = false" @updateBotIndex="updateBotIndex"/>
        <bot-create-form :visible="showCreateForm" @close="showCreateForm = false"></bot-create-form>
        <v-snackbar
            v-model="snackbar"
            bottom
            :color="paramsSnackbar.color"
            right
        >
            {{ paramsSnackbar.text }}
            <v-btn
                dark
                text
                @click="snackbar = false"
            >
                Закрыть
            </v-btn>
        </v-snackbar>
    </div>
</template>
<script>
import DialogConfirmation from '../components/dialogs/DialogConfirmation'
import BotForm from '@components/bot/bot/BotForm'
import BotCard from '@components/bot/bot/BotCard'
import BotCreateForm from '../components/bot/bot/create/BotCreateForm'
import {mapGetters} from 'vuex'

export default {
    name: 'Bot',
    components: {
        BotCard,
        BotForm,
        DialogConfirmation,
        BotCreateForm
    },
    methods: {
        goTo(url) {
            this.$router.push({path: url})
        },
        async removeBot(index) {
            this.$refs.confirm.open('Удаление Бота', 'Вы действительно хотите удалить?',
                {color: 'red', agree: 'Подтверждаю', cancel: 'Отмена'})
                .then((confirm) => {
                    if (confirm === true) {
                        this.$store.dispatch('bots/removeBot', index).then(response => {
                            if (response !== undefined) {
                                this.notification({color: 'success', text: response.data.success.text})
                            }
                        })
                    }
                })
        },
        editBot(index) {
            this.botIndex = index
            this.showScheduleForm = true
        },
        createBot() {
            this.botIndex = null
            /* Старый тип создания чат бота */
            // this.showScheduleForm = true
            this.showCreateForm = true
        },
        updateBotIndex(value) {
            this.botIndex = value
        },
        notification(notification) {
            this.paramsSnackbar.color = notification.color
            this.paramsSnackbar.text = notification.text
            this.snackbar = true
        }
    },
    data() {
        return {
            showScheduleForm: false,
            showCreateForm: false,
            title: 'Bot page',
            showAlert: false,
            botIndex: null,
            persistent: true,
            snackbar: false,
            paramsSnackbar: {
                color: 'success',
                text: 'Успешно сохранено!'
            },
            visAttachmentForm: false,
            dialogParams: {},
            mobile: false
        }
    },
    computed: {
        ...mapGetters({
            bots: 'bots/bots',
            loadedBots: 'bots/loadedBots',
            getBotIndexById: 'bots/getBotIndexById',
            userProfileLoaded: 'user/userProfileLoaded'
        })
    },
    watch: {
        loadedBots(value) {
            if (value) {
                if (this.$route.query.bot_token) {
                    if (this.$route.query.bot_token === 'success') {
                        /* this.paramsSnackbar.color = 'success'
                        this.paramsSnackbar.text = 'Подключение прошло успешно, продолжайте настройку бота'
                        this.snackbar = true */
                        this.notification({
                            color: 'success',
                            text: 'Подключение прошло успешно, продолжайте настройку бота'
                        })
                        this.botIndex = this.getBotIndexById(+this.$route.query.bot_id)
                        this.showScheduleForm = true
                    }
                }
            }
        }
    },
    created() {
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            this.mobile = true
        }

        if (!this.loadedBots) {
            this.$store.dispatch('bots/loadBots')
        }
        if (!this.userProfileLoaded) {
            this.$store.dispatch('user/loadUser')
        }
        if (this.$route.query.bot_token) {
            if (this.$route.query.bot_token === 'error') {
                let text = ''
                switch (this.$route.query.text) {
                    case 'not_token':
                        text = 'Не найден токен в ответе'
                        break
                    case 'not_found_bot':
                        text = 'Не найден бот'
                        break
                    case 'not_code':
                        text = 'Нет кода в ответном сообщении'
                        break
                }
                this.notification({color: 'error', text: text})
            }
        }
    }
}
</script>

<style scoped lang="scss">
</style>
